import { url } from '@/api/api.js'

var myHeaders = new Headers();
myHeaders.append("Cookie", "mailchimp_landing_site=https%3A%2F%2Fcleancutmeals.ie%2Fwc-auth%2Fv1%2Fauthorize%3Fck_4300411a88c76eace32567945afbe0ea92aeb372%3Dcs_50a10ddbd8d0ca76b6435e53273bf9408645d28d");

var requestOptions = {
  method: 'GET',
  headers: myHeaders,
  redirect: 'follow',  
};

export default {
  state: {
    basicPlans: [],
    allmeals: 0,
    discount: 5,
    discountMaximum: 0,
    discountMin: 0,
    discountStep: 5,
    currentUserID: null,
    currentUserData: {
      plan: '',
      allergiesNo: '',
      allergies: '',
      protein: '',
      days: 0,
      breakfastCount: 0,
      mainCount: 0,
      snacksCount: 0
    },
    popupProduct: {
      category: '',
      oldproductID: null,
      count: 1
    },
    stepItem2Menu: false,
    allergiesBtn: [
        {
          title: 'Yes',
          isActive: false
        },
        {
          title: 'No',
          isActive: false
        }
    ],
    lastStep: true,
    banners: [],
    enableDiscount: false,
    itemsOrder: [],
    weeklyPlan: [
      {
        title: 'Monday',
        view: true
      },
      {
        title: 'Tuesday',
        view: false
      },
      {
        title: 'Wednesday',
        view: false
      },
      {
        title: 'Thursday',
        view: false
      },
      {
        title: 'Friday',
        view: false
      },
      {
        title: 'Saturday',
        view: false
      },
      {
        title: 'Sunday',
        view: false
      }
    ],
  },
  mutations: {
    updateWeeklyPlan(state, payload) {
      state.currentUserData.day = payload || 0;
      state.itemsOrder.day = payload || 0;
    },
    setItemsOrder( state, payload ) {
      state.itemsOrder = payload || [];
    },
    setBasicPlans(state, payload) {
      state.basicPlans = payload || [];
    },
    setEnableDiscount( state, payload) {
      if ( payload ) {
        state.enableDiscount = true;
      }
    },
    setDiscount ( state, payload) {            
        state.discountMaximum = payload || 0;
    },
    setDiscountMin ( state, payload) {            
        state.discountMin = payload || 0;
    },
    setDiscountStep ( state, payload) {            
        state.discountStep = payload || 5;
    },
    setAllmeals ( state, payload) {            
      state.allmeals = payload || [];
    },
    setCurrentUserID ( state, payload ) {
      state.currentUserID = payload || null;
    },
    setCurrentUserData ( state, payload ) {
      if(payload) {
        state.currentUserData = payload;      
      }      
    },
    setPopupProduct ( state, payload ) {  
      state.popupProduct = payload;  
    },
    setStepItem2Menu ( state, payload ) {     
      state.stepItem2Menu = payload || false;  
    },
    setLastStep ( state, payload ) {     
      state.lastStep = payload || false;  
    },
    setBanners ( state, payload ) {     
      state.banners = payload || false;  
    },    
  },
  actions: {
    async getAllSettings({commit}) {
                      
      try {
        const Data = await fetch(url + "/wp-json/cct-wizard/v1/all-settings", requestOptions);            
        const data = await Data.text();
        const dataParse = await JSON.parse(data);
        commit('setBasicPlans', dataParse.plans );
        commit('setEnableDiscount', dataParse.enable_additional_discount);
        commit('setDiscount', dataParse.discount_maximum);
        commit('setDiscountMin', dataParse.discount_min);
        commit('setDiscountStep', dataParse.discount_step);
        commit('setAllmeals', dataParse.number_of_meals);
        commit('setCurrentUserID', dataParse.current_user_id);
        commit('setCurrentUserData', dataParse.user_data);
        commit('setBanners', dataParse.banners);
      } catch ( error ) {
        console.log('error', error.message);
        commit('setError', error.message);
        throw error;          
      }
    },
  },
  getters: {
    basicPlans(state) {
      return state.basicPlans;
    },
    enableDiscount ( state ) {
      return state.enableDiscount;
    },
    discountMaximum ( state ) {
      return state.discountMaximum;
    },
    discountMin ( state ) {
      return state.discountMin;
    },
    discountStep ( state ) {
      return state.discountStep;
    },
    discount ( state ) {
      return state.discount;
    },
    allmeals ( state ) {
      return state.allmeals;
    },
    currentUserID ( state ) {
      return state.currentUserID;
    },
    currentUserData ( state ) {
      return state.currentUserData;
    },
    popupProduct ( state ) {
      return state.popupProduct;
    },
    stepItem2Menu ( state ) {
      return state.stepItem2Menu;
    },
    allergiesBtn ( state ) {
      return state.allergiesBtn;
    },
    lastStep ( state ) {
      return state.lastStep;
    },
    banners ( state ) {
      return state.banners;
    },
    itemsOrder ( state ) {
      return state.itemsOrder;
    },
    weeklyPlan(state) {
      return state.weeklyPlan;
    },
  }
}
